<template>
  <div class="search-input">
    <app-placeholder-input :label="label" :name="name" v-model="internalValue" />
    <button type="submit" class="search" @click="$emit('submit')">
      Search
    </button>
  </div>
</template>

<script>
  import AppPlaceholderInput from '@atoms/PlaceholderInput'

  import ValueInputBindings from '@mixins/ValueInputBindings'

  export default {
    mixins: [ ValueInputBindings ],
    components: {
      AppPlaceholderInput
    },
    props: {
      label: String,
      name: String,
      value: String
    }
  }
</script>
